import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  clients: [],
  clientRequests: [],
  loading: true,
  error: '',
};

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    setClients(state, action) {
      state.clients = action.payload.clients || [];
      state.clientRequests = action.payload.clientRequests || [];
      state.loading = false;
      state.error = action.payload.error || '';
    },
    removeClients(_) {
      return initialState;
    },
    addClient(state, action) {
      state.clients.unshift(action.payload);
    },
    updateClient(state, action) {
      const { id, ...updatedData } = action.payload;
      const index = state.clients.findIndex(client => client.id === id);
      if (index !== -1) {
        state.clients[index] = { ...state.clients[index], ...updatedData };
      }
    },
    removeClientRequest(state, action) {
      state.clientRequests = state.clientRequests.filter(request => request.id !== action.payload);
    },
  },
});

// Selectors
export const getClients = (state) => state.clients;
export const getClientRequests = (state) => state.clients.clientRequests;

// Actions
export const {setClients, removeClients, addClient, updateClient, removeClientRequest} = clientsSlice.actions;

export default clientsSlice.reducer;
